var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvelopeOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M95.6083 38.425L87.5 30.525V10.4167C87.5 4.675 82.8292 0 77.0833 0H22.9167C17.175 0 12.5 4.675 12.5 10.4167V30.5333L4.3875 38.425C1.6 41.1542 0 44.9542 0 48.8542V100H100V48.85C100 44.95 98.4 41.15 95.6083 38.425ZM92.7 41.4083C92.8875 41.5917 93.0625 41.7792 93.2333 41.975L87.5 47.7083V36.3458L92.7 41.4125V41.4083ZM22.9167 4.16667H77.0833C80.5292 4.16667 83.3333 6.97083 83.3333 10.4167V51.8708L60.3125 74.8958C54.8083 80.4042 45.2 80.4083 39.6875 74.8958L16.6667 51.8708V10.4167C16.6667 6.97083 19.4708 4.16667 22.9167 4.16667ZM12.5 36.3458V47.7042L6.76667 41.9708C6.9375 41.775 7.1125 41.5875 7.29583 41.4083L12.5 36.3458ZM95.8333 95.8333H4.16667V48.8542C4.16667 47.7958 4.33333 46.7458 4.64583 45.7458L36.7375 77.8417C40.2792 81.3833 44.9875 83.3333 49.9958 83.3333C55.0042 83.3333 59.7125 81.3833 63.2542 77.8417L95.35 45.7417C95.6625 46.7417 95.8292 47.7875 95.8292 48.85L95.8333 95.8333ZM70.8333 25H29.1667V20.8333H70.8333V25ZM62.5 41.6667H29.1667V37.5H62.5V41.6667Z",
    fill: "#03C9A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeOpened);
export default __webpack_public_path__ + "static/media/envelope_opened.c304212cc56888431846b6de98a61063.svg";
export { ForwardRef as ReactComponent };